import { Pipe, PipeTransform } from '@angular/core';
/*
 * Receives credit card type string truncated (since it is stored in the database as var char (5))
 * and returns the full credit card type string
*/
@Pipe({name: 'creditCardType'})
export class CreditCardTypePipe implements PipeTransform {

  transform(value: string, args?: string[]): any {
    if (!value) return value;
    switch (value) {
        case 'DISCO':
            return 'Discover';
        case 'Disco':
            return 'Discover';
        case 'MASTERCARD':
            return 'Mastercard';
        case 'MASTE':
            return 'Mastercard';
        case 'Maste':
            return 'Mastercard';
        case 'AMEX':
            return 'Amex';
        case 'VISA':
            return 'Visa';
        default:
            return value;
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/pipes/credit-card-type.pipe.ts